import React from 'react';
import { Card, CardContent, Stack, Typography } from '@mui/material';

export default function FinancialReportSummaryCards({ totals }) {
    return (
        <Card>
            <CardContent>
                <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
                    <Card sx={{ flex: 1, backgroundColor: 'rgba(46,125,50,0.08)' }}>
                        <CardContent>
                            <Typography variant="subtitle2" color="success.main">
                                Gesamteinnahmen
                            </Typography>
                            <Typography variant="h5">{totals.income}</Typography>
                        </CardContent>
                    </Card>
                    <Card sx={{ flex: 1, backgroundColor: 'rgba(198,40,40,0.08)' }}>
                        <CardContent>
                            <Typography variant="subtitle2" color="error.main">
                                Gesamtausgaben
                            </Typography>
                            <Typography variant="h5">{totals.expense}</Typography>
                        </CardContent>
                    </Card>
                    <Card sx={{ flex: 1, backgroundColor: 'rgba(21,101,192,0.08)' }}>
                        <CardContent>
                            <Typography variant="subtitle2" color="primary.main">
                                Ergebnis
                            </Typography>
                            <Typography variant="h5">{totals.result}</Typography>
                        </CardContent>
                    </Card>
                </Stack>
            </CardContent>
        </Card>
    );
}
